import { APP_READY, APP_STARTUP } from 'constants/ActionTypes';

// Handles actions that need to be done at application startup
export const appStartup = (alias) => {
  return {
    type: APP_STARTUP,
    alias,
  };
};

// Indicates that app ready to be displayed
export const appReady = () => {
  return {
    type: APP_READY,
  };
};
